/**
 * 거래처(제휴업체) 서비스
 */

import apiClient from './api';
import {
  Partner,
  PartnerFilter,
  PartnerListResponse,
  PartnerSalesStats,
  PartnerSettlement,
  VoucherExchangeStatus,
  ApiKeyResponse,
  ApiKeyInfo,
  ApiKeyHistoryResponse,
  ApiKeyHistoryFilter,
} from '../types/partner';

export const partnerService = {
  /**
   * 거래처 목록 조회
   */
  async getPartners(filter: PartnerFilter = {}): Promise<PartnerListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    const response = await apiClient.get<{ data: PartnerListResponse }>(`/admin/partners?${params.toString()}`);
    return response.data.data;
  },

  /**
   * 거래처 상세 조회
   */
  async getPartner(id: number): Promise<Partner> {
    const response = await apiClient.get<{ data: { partner: Partner } }>(`/admin/partners/${id}`);
    return response.data.data.partner;
  },

  /**
   * 거래처 등록
   */
  async createPartner(data: Partial<Partner>): Promise<Partner> {
    const response = await apiClient.post<{ data: { partner: Partner } }>('/admin/partners', data);
    return response.data.data.partner;
  },

  /**
   * 거래처 수정
   */
  async updatePartner(id: number, data: Partial<Partner>): Promise<Partner> {
    const response = await apiClient.put<{ data: { partner: Partner } }>(`/admin/partners/${id}`, data);
    return response.data.data.partner;
  },

  /**
   * 거래처 삭제
   */
  async deletePartner(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/partners/${id}`);

    throw new Error('Not implemented');
  },

  /**
   * 거래처 판매 통계 조회
   */
  async getPartnerSalesStats(
    partnerId: number,
    periodStart: string,
    periodEnd: string
  ): Promise<PartnerSalesStats> {
    // TODO: 백엔드 API 구현 후 연동
    // const params = new URLSearchParams();
    // params.append('period_start', periodStart);
    // params.append('period_end', periodEnd);
    // const response = await apiClient.get<{ data: { stats: PartnerSalesStats } }>(`/admin/partners/${partnerId}/sales-stats?${params.toString()}`);
    // return response.data.data.stats;

    throw new Error('Not implemented');
  },

  /**
   * 거래처 정산 목록 조회
   */
  async getPartnerSettlements(partnerId: number): Promise<PartnerSettlement[]> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { settlements: PartnerSettlement[] } }>(`/admin/partners/${partnerId}/settlements`);
    // return response.data.data.settlements;

    return [];
  },

  /**
   * 바우처 티켓 교환 현황 조회
   */
  async getVoucherExchangeStatus(partnerId: number): Promise<VoucherExchangeStatus> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { status: VoucherExchangeStatus } }>(`/admin/partners/${partnerId}/voucher-exchange-status`);
    // return response.data.data.status;

    throw new Error('Not implemented');
  },

  /**
   * API Key 생성
   */
  async generateApiKey(partnerId: number): Promise<ApiKeyResponse> {
    const response = await apiClient.post<{ data: ApiKeyResponse }>(
      `/admin/partners/${partnerId}/api-key/generate`
    );
    return response.data.data;
  },

  /**
   * API Key 재생성
   */
  async regenerateApiKey(partnerId: number): Promise<ApiKeyResponse> {
    const response = await apiClient.post<{ data: ApiKeyResponse }>(
      `/admin/partners/${partnerId}/api-key/regenerate`
    );
    return response.data.data;
  },

  /**
   * API Key 조회 (마스킹)
   */
  async getApiKey(partnerId: number): Promise<ApiKeyInfo> {
    const response = await apiClient.get<{ data: ApiKeyInfo }>(
      `/admin/partners/${partnerId}/api-key`
    );
    return response.data.data;
  },

  /**
   * API Key 삭제
   */
  async deleteApiKey(partnerId: number): Promise<void> {
    await apiClient.delete(`/admin/partners/${partnerId}/api-key`);
  },

  /**
   * API Key 이력 조회
   */
  async getApiKeyHistory(partnerId: number, filter: ApiKeyHistoryFilter = {}): Promise<ApiKeyHistoryResponse> {
    const params = new URLSearchParams();
    
    if (filter.action) params.append('action', filter.action);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    const response = await apiClient.get<{ data: ApiKeyHistoryResponse }>(
      `/admin/partners/${partnerId}/api-key/history?${params.toString()}`
    );
    return response.data.data;
  },
};

